"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class AdyenPaymentStatusStore {
    api = new ecommerce_1.AdyenApi(configuration_1.default);
    paymentStatus = new Map();
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            paymentStatus: mobx_1.observable,
            setPaymentStatus: mobx_1.action.bound,
        });
    }
    loadPaymentStatus(orderId) {
        return this.api.getAdyenPaymentStatus({ adyenPaymentStatusRequestBody: { orderId } }).then((status) => {
            this.setPaymentStatus(orderId, status);
            return status;
        });
    }
    setPaymentStatus(orderId, status) {
        this.paymentStatus.set(orderId, status);
    }
}
exports.default = new AdyenPaymentStatusStore();
